"use client";
import React, { useEffect } from "react";
import Button from "./components/generic/Button";
import { useRouter } from "next/navigation";
import "./globals.scss";
import StyledIcon from "./components/generic/StyledIcon";
import useIsMobile from "./hooks/useIsMobile";
import { useDispatch } from "react-redux";
import { setNotFound } from "./lib/features/not-found/notFoundSlice";

export default function Custom404() {
  const router = useRouter();
  const isMobile = useIsMobile();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setNotFound(true));

    return () => {
      dispatch(setNotFound(false));
    };
  }, []);

  return (
    <div className="pt-20">
      {!isMobile && (
        <div className="flex items-center justify-center">
          <StyledIcon icon="notFound" />
        </div>
      )}
      <div className="text-center w-11/12 md:w-4/5 lg:w-3/5 xl:w-4/5 flex-col items-center justify-center mx-auto mt-10 md:mt-0">
        <div className="pt-5 primaryColor font-bold text-5xl lg:text-8xl">
          404
        </div>
        <div className="primaryColor font-semibold text-4xl lg:text-6xl">
          Page Not Found
        </div>
        <div className="additionalThirdColor font-medium text-sm lg:text-2xl mt-3">
          We're sorry, the page you requested could not be found.
        </div>
        <div className="additionalThirdColor font-medium text:sm lg:text-2xl">
          Please go back to the Homepage
        </div>
        {!isMobile && (
          <div className="py-5 justify-center flex">
            <Button
              btnText="Home"
              className="!w-1/6 !xl:w-1/12 genericButtonColor py-1"
              id="back"
              name="home"
              onClick={() => router.replace("/")}
            />
          </div>
        )}
      </div>
      {isMobile && (
        <div
          style={{ height: "50vh" }}
          className="flex items-center justify-center"
        >
          <StyledIcon icon="notFoundMobile" />
        </div>
      )}
      {isMobile && (
        <div className="flex justify-center py-12 mt-5 w-full genericButtonColor fixed bottom-0">
          <Button
            btnText="Home"
            className="!w-3/5 whiteBackground primaryColor font-bold text-xl py-2"
            id="back"
            name="home"
            onClick={() => router.replace("/")}
          />
        </div>
      )}
    </div>
  );
}
